import { dispatch } from 'reffects';
import { registerStateBatteries, store } from 'reffects-store';
import {
  registerCookiesBatteries,
  registerGlobalBatteries,
  registerHttpBatteries,
  registerQueryParamsBatteries,
} from 'reffects-batteries';
import CookiesClient from 'infrastructure/CookiesClient';
import registerHttpEffect from 'effects/http';
import httpClient from 'infrastructure/httpClient';
import { registerCurrentDateTimeCoeffect } from 'coeffects/date';
import registerRouterEffects from 'effects/router';
import registerScrollToEffects from 'effects/scrollTo';
import registerDomEffects from 'effects/dom';
import registerEvents from 'events';
import {
  registerCurrentLocationCoeffect,
  registerLocationOriginCoeffect,
} from 'coeffects/router';
import { registerCacheEffects } from 'effects/cache';
import cache from 'infrastructure/cache';
import registerLegalDocumentEvents from 'components/LegalDocument/events';
import registerCacheEvents from 'events/cache';

async function bootstrap() {
  registerCookiesBatteries(CookiesClient);
  registerGlobalBatteries(window);
  registerHttpBatteries(httpClient);
  registerQueryParamsBatteries(window);
  registerStateBatteries(store);

  registerEvents();
  dispatch('SET_INIT_TIME_TO_STATE');

  registerHttpEffect(httpClient, dispatch);
  registerRouterEffects(window);
  registerDomEffects(document);
  registerScrollToEffects(document);

  registerCurrentDateTimeCoeffect();
  registerLocationOriginCoeffect();
  registerCurrentLocationCoeffect();
  registerLegalDocumentEvents();

  registerCacheEffects(cache);
  registerCacheEvents();

  dispatch('SET_RIGHTS_TO_STATE');
  dispatch('INITIALIZE_TROVIT_DATA');
}

export default bootstrap;
